import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field } from 'redux-form';

//material ui components
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';

//Engage Components
import {
    renderSelect,
} from '../../utils/engageComponents';

//Actions
import { addHelpTile, delHelp_Tile } from '../../actions/helpTileAction';


class ModalHelpTile extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            videoURL: '',
            validUrl: '',
            RepeatValue: { name: 'General' },
            RepeatValueOptions: [{ name: 'General' }, { name: 'Entertainment' }, { name: 'Family' }, { name: 'Community' }, { name: 'My Health' }, { name: 'Profile' }],

            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentDidMount() {
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }

    GetResponseTime = (videoDuration) => {

        let seconds = videoDuration;
        let minutes = 0;

        let repairTimeString = '';

        if (seconds >= 60) {
            minutes = Math.floor(seconds / 60);
            seconds = seconds - (minutes * 60);
            repairTimeString += ` ${minutes} minute(s) ${seconds} second(s) (${minutes}:${seconds})`;
        } else {
            repairTimeString += seconds + ' sec ';
        }

        return repairTimeString;
    };

    async OnSaveHelpTile() {
        if (!this.state.validUrl) {
            return
        }
        let splitValues = this.state.videoURL;
        splitValues = splitValues.split('/');

        let objToSend = {};
        objToSend.id = splitValues[splitValues.length - 1];
        objToSend.group = this.state.RepeatValue.name;

        await this.props.addHelpTile(objToSend);

        this.OnCleanModal();
        this.props.OnAddHandler();
    }

    OnCleanModal() {
        this.setState({
            videoURL: '',
            RepeatValue: { name: 'General' }
        });
    }

    OnCancelModal() {
        this.OnCleanModal();

        this.props.OnCancelHandler();
    }

    async OnDeleteHelp(id) {
        await this.props.delHelp_Tile(id);

        this.props.OnDeleteHandler();
    }

    OnRepeatValueChangeHandler = (e, newItem) => {
        this.setState({ RepeatValue: newItem });
    }

    onVideoUrlChange = (e) => {
        try {
            const newDesc = (e && e.target && e.target.value) ? e.target.value : '';

            this.setState({ videoURL: newDesc, validUrl: newDesc.includes("https://vimeo.com/") });

        } catch (err) { }
    }

    RenderModalContent = ({ helpTile }) => {
        if (helpTile != null)
            return (
                <Grid>
                    <Paper elevation={3} className="paperModalMenuItem" square='false' color='secondary'>
                        <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                            {/* Title */}
                            <Grid item container alignItems='center' className="TitleRepairsModal">Help Tile Details</Grid>
                            {/* Image */}
                            <Grid item container className="RepairsModalContainer">
                                <Grid item container justify='center' alignItems='flex-start' className="ModalmenuItemsContainer">
                                    {
                                        (helpTile) &&
                                        <Grid id={`helptile_${helpTile._id}`} item container className="padding5">
                                            <Grid item direction="row" spacing={0} className="menuItemBackground alingCenter">
                                                <Grid item xs={12}>
                                                    {/* Image */}
                                                    <Grid item container className="alingCenter" >
                                                        <img
                                                            className="MenuItemImg"
                                                            src={helpTile.thumbnailURL}
                                                            alt={helpTile.title}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                                {/* Details */}
                                <Grid item container className="ModalButtonsContainer alingCenter" justify='flex-end'>
                                    <Grid item container justify='center' alignItems='flex-start' className="ModalmenuItemsContainer">
                                        {
                                            (helpTile) &&
                                            <Grid item container xs={12} direction='row'>
                                                <Grid item container xs={12}>
                                                    <Grid item container xs={12} className='helpTileInfo' direction='column' alignItems='flex-start' justify='space-around'>
                                                        <Grid item container>
                                                            <Grid item xs={3} className='titleActivityStyleHeaders'>
                                                                Description:
                                                            </Grid>
                                                            <Grid item xs={9} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                                                {
                                                                    helpTile.description
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={3} className='titleActivityStyleHeaders'>
                                                                Duration:
                                                            </Grid>
                                                            <Grid item xs={9} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                                                {
                                                                    this.GetResponseTime(helpTile.videoLength)
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={3} className='titleActivityStyleHeaders'>
                                                                Group:
                                                            </Grid>
                                                            <Grid item xs={9} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                                                {
                                                                    helpTile.group
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={3} className='titleActivityStyleHeaders'>
                                                                Video Url:
                                                            </Grid>
                                                            <Grid item xs={9} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                                                <a href={helpTile.videoURL} rel="noopener noreferrer" target='_blank'>{helpTile.videoURL}</a>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                                {/* Buttons */}
                                <Grid item container className="alingCenter" justify='flex-end'>
                                    <Grid item container className="alingCenter" direction='row'>
                                        <Grid item container className="appbtnModal-engage appbtnBarButton ModalButtonsStyles graybtn-engage alingCenter">
                                            <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.OnCancelModal()}>
                                                Cancel
                                            </Grid>
                                        </Grid>
                                        <Grid item container className="blueBottomButon appbtnBarButton redButton ModalButtonsStyles alingCenter">
                                            <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.OnDeleteHelp(helpTile._id)}>
                                                Delete
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            );
        else
            return (
                <Grid>
                    <Paper elevation={3} className="paperModalNewHelpItem" square='false' color='secondary'>
                        <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                            {/* Title */}
                            <Grid item container alignItems='center' className="TitleRepairsModal"> New Help Tile</Grid>
                            {/* Image */}
                            <Grid item container className="HelpItemModalContainer">
                                {/* Details */}
                                <Grid item container className="ModalButtonsContainer alingCenter" justify='flex-end'>
                                    <Grid item container justify='center' alignItems='flex-start' className="ModalmenuItemsContainer">
                                        <Grid item container xs={12} direction='row'>
                                            <Grid item container xs={12}>
                                                <Grid item container xs={12} className='helpTileInfo' direction='column' alignItems='flex-start' justify='space-around'>
                                                    <Grid item container>
                                                        <Grid item xs={3} className='titleActivityStyleHeaders'>
                                                            Group:
                                                        </Grid>
                                                        <Grid item xs={9} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                                            <Field
                                                                showStartAdornment={true}
                                                                name="RepeatValue"
                                                                label="Repeats"
                                                                maxLength={20}
                                                                selected={this.state.RepeatValue ? this.state.RepeatValue : { name: 'General' }}
                                                                optionsItemsIconsData={this.state.RepeatValueOptions ? this.state.RepeatValueOptions : [{ name: 'General' }]}
                                                                onChangeHandler={(e, newItem) => this.OnRepeatValueChangeHandler(e, newItem)}
                                                                component={renderSelect}
                                                                diableClear={true}
                                                                idToSet="RepeatValue"
                                                                id='RepeatValue'
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item container>
                                                        <Grid item xs={3} className='titleActivityStyleHeaders'>
                                                            Video Url:
                                                        </Grid>
                                                        <Grid item xs={9} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                                            <TextField
                                                                id='help_tile_video_url'
                                                                label={'Video Url'}
                                                                placeholder={'Example: "https://vimeo.com/123456"'}
                                                                style={{ width: '100%', paddingRight: '15px', color: '#606060' }}
                                                                value={this.state.videoURL ? this.state.videoURL : ''}
                                                                maxLength={100}
                                                                onChange={this.onVideoUrlChange} />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* Buttons */}
                                <Grid item container className="alingCenter" justify='flex-end'>
                                    <Grid item container className="alingCenter" direction='row'>
                                        <Grid item container className="appbtnModal-engage appbtnBarButton ModalButtonsStyles graybtn-engage alingCenter">
                                            <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.OnCancelModal()}>
                                                Cancel
                                            </Grid>
                                        </Grid>
                                        <Grid item container style={{ opacity: !this.state.validUrl ? '56%' : '100%', cursor: !this.state.validUrl ? 'not-allowed' : 'pointer' }}
                                            className="blueBottomButon appbtnBarButton ModalButtonsStyles alingCenter"
                                        >
                                            <Grid id='close_repair_return_btn' item container className="alingCenter"
                                                onClick={() => this.OnSaveHelpTile()}>
                                                Save
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            );

    };



    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent helpTile={this.props.helpTile ? this.props.helpTile : null} />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {
    return {}
}


export default connect(mapStateToProps, { addHelpTile, delHelp_Tile })(ModalHelpTile);

